module.exports = __webpack_public_path__ + "static/media/search.81a9e938.png";